import {from as observableFrom, Observable} from 'rxjs';

import {mergeMap, take} from 'rxjs/operators';
import {Injectable, Injector, OnInit} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {User} from '../services/api.client';
import {SystemService} from '../services/SystemService';
import {SupportAgreementComponent} from '../components/energyassistance/support/agreements/SupportAgreementComponent';
import {SecurityService} from '../services/SecurityService';

@Injectable()
export class HasAgreementDate {

    user$: Observable<User>;
    user: User;

    constructor(
        private systemService: SystemService,
        private inject: Injector,
        private _securityService: SecurityService) {
        this.user$ = this._securityService.currentUser$;
        this.user$.subscribe(user => this.user = user);
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const router: Router = this.inject.get(Router);
        return this.user$.pipe(
            take(1),
            mergeMap((user) => {
                // No signed-in user means the session is gone (e.g. the API token
                // interceptor just logged out on a 401). The agreement check only
                // applies to an authenticated user — redirecting here would hijack
                // the in-flight /login navigation and strand the user in the shell.
                if (!user) {
                    return observableFrom([true]);
                }
                if (!this.systemService.loggedInUserHasAgreed() &&
                    state.url !== '/app/support/agreements') {
                    router.navigate(['/app/support/agreements']).then();
                    return observableFrom([false]);
                } else {
                    return observableFrom([true]);
                }
            }),);
    }

    canDeactivate(component: SupportAgreementComponent,
                  route: ActivatedRouteSnapshot,
                  state: RouterStateSnapshot)
        : Observable<boolean> | Promise<boolean> | boolean {
        const router: Router = this.inject.get(Router);
        return this.user$.pipe(
            take(1),
            mergeMap((user) => {
                // Same as canActivate: a logged-out user must be free to leave
                // /app (the logout flow navigates to /login through here).
                if (!user) {
                    return observableFrom([true]);
                }
                if (!this.systemService.loggedInUserHasAgreed()) {
                    if (state.url !== '/app/support/agreements') {
                        router.navigate(['/app/support/agreements']).then();
                    }
                    return observableFrom([false]);
                } else {
                    return observableFrom([true]);
                }
            }),);
    }
}
